module.exports = __webpack_public_path__ + "media/brightjoy.b68a0537.webm";